import { render, staticRenderFns } from "./add-edit-library.vue?vue&type=template&id=2f257c48&scoped=true&"
import script from "./add-edit-library.vue?vue&type=script&lang=js&"
export * from "./add-edit-library.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f257c48",
  null
  
)

export default component.exports